/* eslint-disable @typescript-eslint/no-non-null-assertion */

export function formatProduct(product) {
  return {
    item_id: product.product_id,
    item_name: product.name,
    price: product.price,
    quantity: product.quantity
  };
}
export default function checkoutStarted({
  properties
}) {
  return {
    name: "begin_checkout",
    properties: {
      currency: properties.currency || "USD",
      value: properties.total || properties.revenue,
      coupon: properties.coupon,
      items: properties.products.map(formatProduct)
    }
  };
}